import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();


    function buildFormat() {
      var $toc = $('<div />', {id: 'toc_container'});
      var $list = $('<ul />', {class: 'toc_list'});
      var $groups = $('.u-format-group');
      // フォーマットグループごとの処理
      for (var i = 0; i < $groups.length; i++) {
        var $_list = $('<ul />');
        var $group = $($groups[i]);
        var group_title = $group.find('.u-format-group__title').text();
        var $group_li = $('<li />');
        var groupid = 'formatgroup_' + (i + 1);
        $group.attr('id', groupid);
        $list.append(
          $group_li.append(
            $('<a />',
              {
                text: (i + 1) + '. ' + group_title,
                href: '#' + groupid
              }
            )
          )
        );
        // フォーマットごとの処理
        var $formats = $group.find('.u-format-group__content').find('.u-format');
        var $_ul = $('<ul />');
        for (var m = 0; m < $formats.length; m++) {
          var $format = $($formats[m]);
          var $format_title = $format.find('.u-format__title');
          var $format_content = $format.find('.u-format__content');
          var formatid = 'format_' + (i + 1) + (m + 1);
          $format.find('.u-format__title').attr('id', formatid);
          var format_title = $format_title.text();
          var format_number = (i + 1) + '.' + (m + 1) + '. ';
          $format_title.text(format_number + format_title);
          $_ul.append(
            $('<li />').append(
              $('<a />', {
                  href: '#' + formatid,
                  text: format_number + format_title
                }
              )
            )
          );

          // コードを追加
          var $code = $('<div />', {class: 'u-format__code'});
          $code.append($('<div />', {
            class: 'u-format__code__title',
            text: format_number + format_title
          }));
          var formathtml = $format.find('.u-format__content').html();
          $code.append($('<pre />', {text: formathtml.trim()}));
          $format.append($code);
        }
        $group_li.append($_ul);
        $_list.append($group_li);
        $list.append($_list);
      }
      $toc.append($list);
      $('.c-breadcrumb').after(
        $('<div />', {
            class: 'l-container'
          }
        ).append($toc)
      );
    }

    $(function() {
        var owls = $('.owl-carousel');
        if (owls.length === 0) {
            return false
        }
        owls.imagesLoaded(function () {



            //var $top = $('.c-interview-slider .c-interview-slider__slider');
            /*
            $top.owlCarousel({
                items: 4,
                margin: 16
            });
            */


            //slidr interview
            var $interview = $('.c-interview-slider .c-interview-slider__slider');
            $interview.owlCarousel({
                items: 3,
                margin: 32,
                dots: false,
                loop: true,
                nav: true,
                autoplayHoverPause: true,
                //autoplay: true,
                autoplaySpeed: 500,
                center: true,
                navText: ['<img src="/wp-content/themes/odawara-eng-html/dist/assets/images/icon-slider-prev.png" />','<img src="/wp-content/themes/odawara-eng-html/dist/assets/images/icon-slider-next.png" />'],
                responsive: {
                    0:{
                        items:1,
                        nav:true,
                        margin: 0
                    },
                    950:{
                        items:3,
                        margin: 32
                    }
                }
            });

            var $interviewTop = $('.c-ov-xlg-block .c-ov-xlg-block__slider');
            $interviewTop.owlCarousel({
                center: false,
                loop: true,
                margin: 48,
                autoWidth: false,
                nav: true,
                //autoplay: true,
                navText: ['<img src="/wp-content/themes/odawara-eng-html/dist/assets/images/icon-slider-prev-top.png" />','<img src="/wp-content/themes/odawara-eng-html/dist/assets/images/icon-slider-next-top.png" />'],
                autoplaySpeed: 1000,
                dots: true,
                responsive: {
                    0: {
                        items: 1,
                        margin: 0,
                    },
                    950: {
                        items: 2,
                        margin: 19,
                    }
                }

            });


        });
      //buildFormat();
    });
  }
}

window.GApp = new App();


(function ($) {

    var growApp = function () {
    };
    /*
     * userAgent取得
     * */
    var Agent = window.navigator.userAgent.toLowerCase();
    var _ua = (function (u) {
        return {
            Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
            || u.indexOf("ipad") != -1
            || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
            || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
            || u.indexOf("kindle") != -1
            || u.indexOf("silk") != -1
            || u.indexOf("playbook") != -1,
            Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
            || u.indexOf("iphone") != -1
            || u.indexOf("ipod") != -1
            || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
            || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
            || u.indexOf("blackberry") != -1
        }
    })(Agent);


    /*
    growApp.prototype.footerMenu = function () {
        var win = $(window).innerWidth();
        if (win > 750) {
            return false;
        }
        $('.c-footer-menu__block').on('click',function() {
            $(this).children(".c-footer-menu__title").toggleClass('is-open');
            $(this).children(".c-footer-menu__list.is-sub").slideToggle();
        })
    }
    */
    //buttonWrap
    growApp.prototype.buttonWrap = function () {
        var $button = $(".c-button");
        $button.wrapInner("<span></span>");
    }

    //profileClose
    growApp.prototype.profileClose = function () {
        var $button = $(".c-accordion__close .c-button");
        $button.on("click",function(){
            $(this).parents(".c-accordion__content").slideUp();
            if($(this).parents(".c-accordion").hasClass("is-open")){
                $(this).parents(".c-accordion").removeClass("is-open");
            }
        });
    }

    //productsParts
    growApp.prototype.productsParts = function () {
        //存在チェック
        var $obj = $("#productsParts");
        if(!$obj.length){
            return false;
        }

        //変数宣言
        var $parts = $("#productsParts .js-products-parts");
        var $img = $("#productsParts .js-products-image");

        //製品カテゴリー取得
        var $productsClass = $("#productsParts").attr('class').split(' ');
        var $productsNameLen = $productsClass.length;
        var $productsName = $productsClass[$productsNameLen-1];

        //処理
        $parts.on("mouseover",function(){
            var partsIndex = ($(this).index()) + 1;
            if(partsIndex <= 9){
              $img.attr("src","/wp-content/themes/odawara-eng-html/dist/assets/images/img-" + $productsName + "-all-0" + partsIndex + ".png");
            }else if(partsIndex >= 10){
              $img.attr("src","/wp-content/themes/odawara-eng-html/dist/assets/images/img-" + $productsName + "-all-" + partsIndex + ".png");
            }
            }).on("mouseout",function(){
                $img.attr("src","/wp-content/themes/odawara-eng-html/dist/assets/images/img-" + $productsName + "-all.png");
            });
    }

    //mainVisual
    growApp.prototype.mainVisual = function () {
        //変数宣言
        let $texts = $(".c-main-visual__texts");
        let $overLay = $(".c-main-visual__overlay");
        let $video = $(".c-main-visual__video");
        let $mainVisual = $(".c-main-visual");
        let $lead = $(".c-main-visual__lead");


        //処理1
        function anim (callback){
            let durationText = 2000;
            setTimeout(function(){
                $texts.fadeIn(durationText);
                $texts.addClass("is-active");
                callback();
            },1000);
        }
        //処理2
        function videoShow(){
            let durationOverLay = 3000;
            let durationVideo = 3000;
            let durationDecoration = 2000;
            setTimeout(function(){
                $overLay.fadeOut(durationOverLay);
                $lead.addClass("is-hidden");
                $video.fadeIn(durationVideo);
                $mainVisual.addClass("is-active");
            },3000);
        }

        //実行
        anim(videoShow);

    }



    $(function () {
        var app = new growApp();
        //app.footerMenu();
        app.buttonWrap();
        app.profileClose();
        app.productsParts();
        app.mainVisual();
    });

})(jQuery);
